import React, { useCallback } from 'react';
import { useAppDispatch } from 'flow/hooks/useRedux';
import useAppContext from 'flow/hooks/useAppContext';
import { setActiveMeetingMemberListActiveStatus } from 'flow/actions/meeting-actions';

/**
 * The trailing "+N" cell shown when feeds don't all fit. Clicking it opens the
 * participants panel, where the hidden participants are listed.
 */
const TileFeedOverflow: React.FC<{ count: number }> = ({ count }) => {
    const dispatch = useAppDispatch();
    const { i18next } = useAppContext();

    const openParticipants = useCallback(() => {
        dispatch(setActiveMeetingMemberListActiveStatus(true));
    }, [dispatch]);

    // Spell out the hidden count so assistive tech conveys how many
    // participants the "+N" tile conceals, not just that it's a button.
    const hiddenParticipantsLabel = `${count} ${
        count > 1
            ? i18next.t('videoconference.gridlimit_more_participants')
            : i18next.t('videoconference.gridlimit_more_participant')
    }`;

    return (
        <button
            type="button"
            onClick={openParticipants}
            aria-label={hiddenParticipantsLabel}
            className="hover:darken-10 flex h-full w-full cursor-pointer items-center justify-center rounded-lg border-none bg-gray-700 text-lg font-semibold text-white"
        >
            {`+${count}`}
        </button>
    );
};

export default TileFeedOverflow;
